import { IConvertSize } from 'shared/types/ConvertSize';
import { requestService } from 'shared/utils/services/requestService';

interface IGetSizeConversion {
  fromBrand?: string;
  fromGender: string;
  fromUnit: string;
  productType: string;
  toBrand?: string;
  toGender: string;
  toUnit: string;
  userSize: string;
}

// TODO: Refactor other places calling this API to reuse this
// Removed hardcoded list and mand toBrand optional: https://goatapp.atlassian.net/browse/EVO-1677
export const getSizeConversion = async ({
  fromBrand,
  fromGender,
  fromUnit,
  productType,
  toBrand,
  toGender,
  toUnit,
  userSize,
}: IGetSizeConversion) => {
  try {
    const { data: convertedSize }: { data: IConvertSize } = await requestService({
      url: '/web-api/v1/convert_size',
      method: 'post',
      data: JSON.stringify({
        size: String(userSize),
        from_brand: fromBrand || 'default',
        ...(toBrand && { to_brand: toBrand?.toLowerCase() }),
        from_gender: fromGender?.toUpperCase(),
        to_gender: toGender?.toUpperCase(),
        from_unit: fromUnit?.toUpperCase(),
        to_unit: toUnit?.toUpperCase(),
        product_type: productType?.toUpperCase(),
      }),
    });

    return convertedSize;
  } catch {
    return null;
  }
};
